import type { RuleOptionGroup } from "./getDemoData.types"

export const APPROVED_INTERNAL_MCP_SERVERS = [
  "stdio://mcp-server-git",
  "https://mcp-obs.kodem-demo.internal/mcp",
  "https://mcp-docs.kodem-demo.internal/mcp"
]

export const OBSERVED_NETWORK_DESTINATIONS = [
  "*.kodem-demo.internal",
  "api.github.com",
  "kodem.atlassian.net",
  "slack.com",
  "services.nvd.nist.gov"
]

export const getAssetsScope = () => [
  {
    label: "Environment",
    value: "environment" as any,
    id: "environment",
    displayName: "Environment",
    placeholder: "Select",
    valueType: "SELECT" as const,
    opts: [
      {
        id: "production",
        displayName: "Production"
      },
      {
        id: "staging",
        displayName: "Staging"
      },
      {
        id: "development",
        displayName: "Development"
      }
    ]
  },
  {
    label: "Application",
    value: "application" as any,
    id: "application",
    displayName: "Application",
    placeholder: "Select",
    valueType: "SELECT" as const,
    opts: [
      {
        id: "devops-remediator",
        displayName: "devops-remediator"
      },
      {
        id: "support-bot",
        displayName: "support-bot"
      },
      {
        id: "code-triage",
        displayName: "code-triage"
      },
      {
        id: "research-assistant",
        displayName: "research-assistant"
      }
    ]
  },
  {
    label: "Agent",
    value: "agent" as any,
    id: "agent",
    displayName: "Agent",
    placeholder: "Select",
    valueType: "SELECT" as const,
    opts: []
  },
  {
    label: "Tag",
    value: "tag" as any,
    id: "tag",
    displayName: "Tag",
    placeholder: "select",
    valueType: "SELECT" as const,
    opts: [
      {
        id: "pci",
        displayName: "pci"
      },
      {
        id: "customer-data",
        displayName: "customer-data"
      },
      {
        id: "internal-only",
        displayName: "internal-only"
      }
    ]
  }
]

export const getOptions = (): RuleOptionGroup[] => [
  {
    displayName: "Model",
    title: "model",
    options: [
      {
        id: "modelProvider",
        type: "single",
        displayName: "Model provider",
        scope: "only",
        options: [
          { label: "Anthropic", value: "anthropic" },
          { label: "OpenAI", value: "openai" },
          { label: "Google", value: "google" },
          { label: "Meta", value: "meta" },
          { label: "Mistral AI", value: "mistral-ai" },
          { label: "Cohere", value: "cohere" },
          { label: "xAI", value: "xai" },
          { label: "DeepSeek", value: "deepseek" },
          { label: "Alibaba (Qwen)", value: "alibaba-qwen" },
          { label: "Moonshot AI", value: "moonshot-ai" },
          { label: "Amazon", value: "amazon" },
          { label: "Microsoft", value: "microsoft" },
          { label: "Other open-weight", value: "other-open-weight" },
          { label: "Unknown", value: "unknown" }
        ]
      },
      {
        id: "modelName",
        type: "single",
        displayName: "Model name",
        scope: "only",
        options: [
          { label: "Anthropic", value: "anthropic" },
          { label: "OpenAI", value: "openai" },
          { label: "Google", value: "google" },
          { label: "Meta", value: "meta" },
          { label: "Mistral AI", value: "mistral-ai" },
          { label: "Cohere", value: "cohere" },
          { label: "xAI", value: "xai" },
          { label: "DeepSeek", value: "deepseek" },
          { label: "Alibaba (Qwen)", value: "alibaba-qwen" },
          { label: "Moonshot AI", value: "moonshot-ai" },
          { label: "Amazon", value: "amazon" },
          { label: "Microsoft", value: "microsoft" },
          { label: "Other open-weight", value: "other-open-weight" },
          { label: "Unknown", value: "unknown" }
        ]
      },
      {
        id: "modelPlatform",
        type: "single",
        displayName: "Model platform",
        scope: "only",
        options: [
          { label: "Direct provider API", value: "direct-provider-api" },
          { label: "AWS Bedrock", value: "aws-bedrock" },
          {
            label: "Azure AI Foundry / Azure OpenAI",
            value: "azure-ai-foundry"
          },
          { label: "Google Vertex AI", value: "google-vertex-ai" },
          { label: "Self-hosted", value: "self-hosted" },
          { label: "Third-party router", value: "third-party-router" },
          { label: "Unknown", value: "unknown" }
        ]
      }
    ]
  },
  {
    displayName: "Tool",
    title: "tool",
    options: [
      {
        id: "toolAccessType",
        type: "single",
        displayName: "Tool access type",
        scope: "only",
        options: [
          { label: "Network", value: "network" },
          { label: "File system", value: "file-system" },
          { label: "Dynamic code execution", value: "execution" }
        ]
      },
      {
        id: "toolBehavior",
        type: "single",
        displayName: "Tool behavior",
        scope: "is",
        options: [
          {
            label: "Within intended behavior",
            value: "within-intended-behavior"
          }
        ]
      },
      {
        id: "toolName",
        type: "single",
        displayName: "Tool name",
        scope: "only",
        options: [
          { label: "account specialist", value: "account-specialist" },
          { label: "ack pagerduty", value: "ack-pagerduty" },
          { label: "add citations", value: "add-citations" },
          { label: "apply credit", value: "apply-credit" },
          { label: "apply patch", value: "apply-patch" },
          { label: "billing specialist", value: "billing-specialist" },
          { label: "build patch", value: "build-patch" },
          { label: "classify intent", value: "classify-intent" },
          { label: "classify severity", value: "classify-severity" },
          { label: "code_execution", value: "code-execution" },
          { label: "comms specialist", value: "comms-specialist" },
          { label: "create github issue", value: "create-github-issue" },
          { label: "create notion page", value: "create-notion-page" },
          { label: "create ticket", value: "create-ticket" },
          { label: "cvss score", value: "cvss-score" },
          { label: "dedupe sources", value: "dedupe-sources" },
          { label: "dedupe v2", value: "dedupe-v2" },
          { label: "delegate to deduper", value: "delegate-to-deduper" },
          { label: "delegate to fixer", value: "delegate-to-fixer" },
          { label: "delegate to reporter", value: "delegate-to-reporter" },
          { label: "delegate to reviewer", value: "delegate-to-reviewer" },
          { label: "depsdev lookup", value: "depsdev-lookup" },
          { label: "describe instances", value: "describe-instances" },
          { label: "diff stats", value: "diff-stats" },
          { label: "escalation specialist", value: "escalation-specialist" },
          { label: "extract entities", value: "extract-entities" },
          { label: "fetch", value: "fetch" },
          { label: "format reply", value: "format-reply" },
          { label: "format runbook", value: "format-runbook" },
          { label: "fraud specialist", value: "fraud-specialist" },
          { label: "get alert", value: "get-alert" },
          { label: "get charges", value: "get-charges" },
          { label: "get customer", value: "get-customer" },
          { label: "get cve", value: "get-cve" },
          { label: "get doc meta", value: "get-doc-meta" },
          { label: "get metrics", value: "get-metrics" },
          { label: "get pd incident", value: "get-pd-incident" },
          { label: "get subscription", value: "get-subscription" },
          { label: "git add", value: "git-add" },
          { label: "git branch", value: "git-branch" },
          { label: "git checkout", value: "git-checkout" },
          { label: "git commit", value: "git-commit" },
          { label: "git create branch", value: "git-create-branch" },
          { label: "git diff", value: "git-diff" },
          { label: "git diff staged", value: "git-diff-staged" },
          { label: "git diff unstaged", value: "git-diff-unstaged" },
          { label: "git log", value: "git-log" },
          { label: "git reset", value: "git-reset" },
          { label: "git show", value: "git-show" },
          { label: "git status", value: "git-status" },
          { label: "github code search", value: "github-code-search" },
          { label: "investigator tool", value: "investigator-tool" },
          { label: "kb retriever tool", value: "kb-retriever-tool" },
          { label: "lint snippet", value: "lint-snippet" },
          { label: "list alerts", value: "list-alerts" },
          { label: "list buckets", value: "list-buckets" },
          { label: "list collections", value: "list-collections" },
          { label: "list customers", value: "list-customers" },
          { label: "list docs", value: "list-docs" },
          { label: "list kev", value: "list-kev" },
          { label: "list logs", value: "list-logs" },
          { label: "list tickets", value: "list-tickets" },
          { label: "lookup order", value: "lookup-order" },
          { label: "mask card", value: "mask-card" },
          { label: "notifier tool", value: "notifier-tool" },
          { label: "notify slack", value: "notify-slack" },
          { label: "nvd lookup", value: "nvd-lookup" },
          { label: "osv lookup", value: "osv-lookup" },
          { label: "parse alert", value: "parse-alert" },
          { label: "parse metric", value: "parse-metric" },
          { label: "parse sarif", value: "parse-sarif" },
          { label: "post to slack", value: "post-to-slack" },
          { label: "post to teams", value: "post-to-teams" },
          { label: "process refund", value: "process-refund" },
          { label: "rank findings", value: "rank-findings" },
          { label: "read doc", value: "read-doc" },
          { label: "remediator tool", value: "remediator-tool" },
          { label: "run remediation", value: "run-remediation" },
          { label: "run tests", value: "run-tests" },
          { label: "scale service", value: "scale-service" },
          { label: "search advisories", value: "search-advisories" },
          { label: "search docs", value: "search-docs" },
          { label: "search logs", value: "search-logs" },
          { label: "search web", value: "search-web" },
          { label: "send email", value: "send-email" },
          { label: "send sms", value: "send-sms" },
          { label: "sentiment", value: "sentiment" },
          { label: "summarize", value: "summarize" },
          { label: "summarize finding", value: "summarize-finding" },
          { label: "summarize ticket", value: "summarize-ticket" },
          { label: "tail log", value: "tail-log" },
          { label: "tavily search", value: "tavily-search" },
          { label: "terminate instance", value: "terminate-instance" },
          { label: "triager tool", value: "triager-tool" },
          { label: "validator tool", value: "validator-tool" },
          { label: "web researcher tool", value: "web-researcher-tool" },
          { label: "Unknown", value: "unknown" }
        ]
      },
      {
        id: "toolCategory",
        type: "single",
        displayName: "Tool category",
        scope: "only",
        options: [
          { label: "Human / external input", value: "human-external-input" },
          { label: "Web & internet", value: "web-internet" },
          { label: "Files & storage", value: "files-storage" },
          { label: "Databases & data stores", value: "databases-data-stores" },
          { label: "Knowledge & memory", value: "knowledge-memory" },
          { label: "Code & development", value: "code-development" },
          { label: "Communication", value: "communication" },
          { label: "Business / SaaS", value: "business-saas" },
          {
            label: "Financial / transactional",
            value: "financial-transactional"
          },
          { label: "Cloud & infrastructure", value: "cloud-infrastructure" },
          {
            label: "Code & command execution",
            value: "code-command-execution"
          },
          { label: "AI & agents", value: "ai-agents" },
          { label: "Data processing", value: "data-processing" },
          { label: "Unknown", value: "unknown" }
        ]
      }
    ]
  },
  {
    displayName: "MCP",
    title: "mcp",
    options: [
      {
        id: "mcpServer",
        type: "single",
        displayName: "MCP server",
        scope: "only",
        options: [
          { label: "stdio://mcp-server-git", value: "stdio://mcp-server-git" },
          {
            label: "https://mcp-obs.kodem-demo.internal/mcp",
            value: "https://mcp-obs.kodem-demo.internal/mcp"
          },
          {
            label: "https://mcp-docs.kodem-demo.internal/mcp",
            value: "https://mcp-docs.kodem-demo.internal/mcp"
          },
          {
            label: "https://mcp-crm.kodem-demo.internal/mcp",
            value: "https://mcp-crm.kodem-demo.internal/mcp"
          },
          {
            label: "https://fetch-mcp.public-tools.dev/mcp",
            value: "https://fetch-mcp.public-tools.dev/mcp"
          },
          {
            label: "https://mcp.vulnfeed.dev/sse",
            value: "https://mcp.vulnfeed.dev/sse"
          }
        ]
      },
      {
        id: "mcpTransport",
        type: "single",
        displayName: "MCP transport",
        scope: "only",
        options: [
          { label: "local", value: "local" },
          { label: "remote", value: "remote" }
        ]
      }
    ]
  },
  {
    displayName: "Dependence",
    title: "dependency",
    options: [
      {
        id: "dependencyRisk",
        type: "single",
        displayName: "Dependency risk",
        scope: "only",
        options: [
          { label: "Malicious package", value: "malicious-package" },
          {
            label: "Reachable vulnerability",
            value: "reachable-vulnerability"
          },
          {
            label: "Unreachable vulnerability",
            value: "unreachable-vulnerability"
          },
          { label: "None", value: "none" },
          { label: "Unknown", value: "unknown" }
        ]
      }
    ]
  },
  {
    displayName: "Agent",
    title: "agent",
    options: [
      {
        id: "delegation",
        type: "single",
        displayName: "Delegation",
        scope: "is",
        options: [{ label: "Yes", value: "Yes" }]
      }
    ]
  },
  {
    displayName: "Network",
    title: "network",
    options: [
      {
        id: "networkDestination",
        type: "single",
        displayName: "Network destination",
        scope: "only",
        options: [
          ...OBSERVED_NETWORK_DESTINATIONS,
          "pypi.org",
          "registry.npmjs.org",
          "api.openai.com",
          "api.anthropic.com"
        ]
          .map((host) => ({ label: host, value: host }))
          .concat({ label: "Unknown", value: "unknown" })
      },
      {
        id: "internetAccess",
        type: "single",
        displayName: "Internet access",
        scope: "is",
        options: [{ label: "Yes", value: "Yes" }]
      }
    ]
  }
]

export const getOptionById = (id: string) => {
  const options = getOptions()

  return options
    .flatMap((group) => group.options)
    .find((option) => option.id === id)
}

// Agents the hardening suggestions are offered for.
export const HARDENING_AGENT_NAMES = ["TriageAgent", "RemediationLead"]
